import styled from 'styled-components';
import { borderRadius, boxShadow, compose, display, height, maxHeight, maxWidth, minHeight, minWidth, overflow, size, space, textAlign, width } from 'styled-system';
import { borderRadiusAttrs } from '../utils/attrs/borderRadiusAttrs';
import { boxShadowAttrs } from '../utils/attrs/boxShadowAttrs';
import { applyVariations, color, colorScheme } from '../utils/utils';
/**
 * @public
 */
export const Box = /*#__PURE__*/styled.div.attrs(props => ({
  ...borderRadiusAttrs(props),
  ...boxShadowAttrs(props)
})).withConfig({
  displayName: "Box",
  componentId: "sc-n9h3nv-0"
})(["", " ", " ", " ", ""], applyVariations('Box'), color, colorScheme, props => compose(width, display, height, maxHeight, maxWidth, minHeight, minWidth, size, space, textAlign, borderRadius, boxShadow, overflow)(props));
Box.displayName = 'Box';